// extracted by mini-css-extract-plugin
export default {"notificationContainer":"FloatNotification_notificationContainer__iwilq","darwinAlert":"FloatNotification_darwinAlert__ycuWN"};